<script lang="ts">
	import type { Snippet } from "svelte";
	import Media from "./common/Media.svelte";
	import type { MediaSrc } from "./common/MediaSrc.js";

	const { image, title, description }: { image?: MediaSrc | Snippet; description: string; title: string } = $props();
</script>

<div class="grow group [counter-increment:step-list]">
	<div class="flex flex-col items-center max-w-86 mx-auto">
		<div
			class="after:content-[counter(step-list)] bg-nov-light-000 text-7/8 xs:text-title2 text-nov-red-300 rounded-full mt-6 mb-5 lg:mt-12 flex items-center size-16 xs:size-18 lg:mb-8 justify-center"
		></div>
		<div class="relative">
			{#if typeof image === "function"}
				{@render image()}
			{:else if image}
				<Media
					width={300}
					height={300}
					source={image}
					alt={title}
					class="relative z-20 size-65 xs:size-72 rounded-md object-cover"
				/>
			{/if}
			<div
				class="hidden lg:flex h-auto absolute row-span-4 row-start-2 group-first:hidden overflow-hidden gap-3 top-1/2 -translate-y-1/2 -left-3 -translate-x-full"
			>
				{#each Array.from({ length: 8 }, () => 0) as _, i (i)}
					<div class="size-1 rounded-full bg-nov-red-300"></div>
				{/each}
			</div>
		</div>
		<h3 class="h3 mt-5 lg:mt-10 mb-2 lg:mb-4 text-center font-bold !text-nov-red-300">{title}</h3>
		<p class="text-center tracking-[0.005em] text-nov-dark-800">{description}</p>
	</div>
</div>
